import Logo from'./logo-extension';import{componentFactory,getValidValue}from'../../../fc-core/src/lib';let isRequiredComponent=(a,b)=>a.getType()===b;export default{extension:function(a){a.addEventListener('instantiated',function(a){let b=a.sender;isRequiredComponent(b,'chartAPI')&&b.registerFactory('logo',function(a){let b=a.getFromEnv('chart-attrib'),c=getValidValue(b.logourl,'');componentFactory(a,Logo,'logo',c?1:0,[b])})})},name:'LogoExtension',type:'extension',requiresFusionCharts:!0};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-features/src/logo/index.js
// module id = null
// module chunks = 